import { useState } from "react";
import { IGeneric2AutoComplete } from "../../_common/interface/autocomplete/iStandard2Autocomplete";
import { dropdownService } from "../../_services/dropdown.service";
import StandardMultipleAutoComplete from "./standardMultiple.autocomplete";

export const DataTypeMultipleAutoComplete = (params: IGeneric2AutoComplete) => {

    const [loadedItems, setLoadedItems] = useState<any[]>([]);

    return (
        <StandardMultipleAutoComplete
            {...params}
            itemsLoader={() => { //Need to do this for teh select All Option
                return dropdownService
                    .fetchFormDataMultiple(params.dataType, params.parentId)
                    .then(items => {
                        if (params.onItemsLoaded) {
                            params.onItemsLoaded(items);
                        }
                        setLoadedItems(items);
                        return items;
                    });
            }}
        />
    );
}